import { snakeCase } from 'lodash';
import { ProjectQuery } from './status-project.models';
import { DateTime } from 'luxon';

export function exportCsv(response: string, query: ProjectQuery): void {
    const a = document.createElement('a');
    const teams = !!query?.teams?.length
        ? `~${query.teams?.map((x) => snakeCase(x)).join('-')}` ?? ''
        : '';
    const envs = !!query?.envs?.length
        ? `~${query.envs?.map((x) => snakeCase(x)).join('-')}` ?? ''
        : '';
    const critical = query.critical ? '~critical' : '';
    const fileName = `iq-project-status${teams}${envs}${critical}~${DateTime.now().toFormat(
        'yyyy-MM-dd_HH-mm-ss',
    )}.csv`;

    a.href = 'data:text/csv,' + response;
    a.setAttribute('download', fileName);

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}
